export default "__VITE_ASSET__C$k5eWDC__"